export default __webpack_public_path__ + "static/media/warranty.e893289f.png";